import React, { useState } from "react";
// import AdminCateEditModal from "./AdminCateEditModal";
import ActiveFormModal from "./ActiveFormModal";
// import defaultPic from "../assets/img/dummy.jpeg";
import AdminEditDriver from "./adminDriver/AdminEditDriver";
import defaultimg from "../assets/img/dummy.jpeg";
import { getAllDrivers, updateUserById } from "../actions/userActions";
import { useDispatch } from "react-redux";

const AdminDriverListRow = ({ current, i }) => {
  const [selectedImage, setSelectedImage] = useState(defaultimg);

  const [showActiveModal, setshowActiveModal] = useState(false);
  const openActiveModal = () => {
    setshowActiveModal((showActiveModal) => !showActiveModal);
  };
  const [showEditModal, setshowEditModal] = useState(false);
  const openEditModal = () => {
    setshowEditModal((showEditModal) => !showEditModal);
  };
  const dispatch = useDispatch();
  // const [values, setValues] = useState({
  //   _id: "",
  //   status: "",
  // });
  const handleSubmit = async (event) => {
    console.log("handleSubmit modal k bhr");

    event.preventDefault();
    const updatedStatus = !current.status; // Toggle the boolean value
    const statusData = {
      // _id: current.id,
      status: updatedStatus, // Assign the toggled value
    };
    dispatch(updateUserById(statusData, current.id ? current.id : current._id));

    setTimeout(() => {
      dispatch(getAllDrivers());
    }, 1000);
    setshowActiveModal(false);
  };
  console.log(current, "currenttttttt driver list");
  return (
    <>
      <tr>
        <td>{i + 1}</td>
        <td>
          {current?.profilePic && current?.profilePic?.fileUrl ? (
            <img
              className="default-pic-height rounded border"
              src={current?.profilePic?.fileUrl}
              alt="Profile Pic"
              width="50"
              height="50"
              // style={{ borderRadius: "50%", height: "100%", width: "100%" }}
            />
          ) : (
            <img
              className="default-pic-height rounded border"
              src={selectedImage}
              alt="Profile Pic"
              width="50"
              height="50"
              // style={{ borderRadius: "50%", height: "100%", width: "100%" }}
            />
          )}
        </td>
        <td>{current?.firstName + " " + current?.lastName}</td>
        <td>{current?.phone ? current?.phone : "-"}</td>
        <td>{current?.email ? current?.email : "-"}</td>
        <td>
          {current?.status === true ? (
            <a
              href="#"
              className="btn btn-sm btn-success"
              onClick={openActiveModal}
            >
              Active
            </a>
          ) : (
            <a
              href="#"
              className="btn btn-sm btn-dark"
              onClick={openActiveModal}
            >
              Deactivated
            </a>
          )}
          <a
            href="#"
            className="btn btn-sm btn-primary mx-1"
            onClick={openEditModal}
          >
            Edit
          </a>
          <a href="#" className="btn btn-sm btn-danger">
            Delete
          </a>
        </td>
      </tr>
      <AdminEditDriver
        openEditModal={openEditModal}
        showEditModal={showEditModal}
        current={current}
      />
      <ActiveFormModal
        openActiveModal={openActiveModal}
        showActiveModal={showActiveModal}
        current={current}
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default AdminDriverListRow;
